import { useMemo } from 'react';
import Card from 'components/ui/Card';
import Select, { SelectOption } from 'components/ui/Select';
import { GraduationCap } from 'assets/icons/revamp';
import { t } from 'services/i18n.service';
import { ATTRIB } from 'constants/test';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateMoreOptionTutorial } from 'store/reducer/modal/slice';
import { moreOptionModalTutorialSelector } from 'store/reducer/modal/more-options.modal.selectors';

const Tutorial: React.FC = () => {
  const dispatch = useAppDispatch();
  const { tutorialId, tutorials, isFetchingTutorials } = useAppSelectorShallow(
    moreOptionModalTutorialSelector
  );

  const tutorialOptions: SelectOption[] = useMemo(
    () =>
      tutorials.map((tutorial) => ({
        label: tutorial.name,
        value: tutorial.id
      })),
    [tutorials]
  );
  const selectedTutorial = useMemo(
    () => tutorials.find((tutorial) => tutorial.id === tutorialId),
    [tutorialId, tutorials]
  );

  return (
    <div
      data-testid={ATTRIB.DATA_TESTID.TUTORIAL_DROPDOWN}
      title={t('tutorial_info_description')}>
      <Card className='flex flex-col ~gap-3/4'>
        <div className='flex-1 flex flex-col ~gap-1/2'>
          <h3 className='~text-xs/sm font-semibold text-black dark:text-white flex items-center ~gap-1/2'>
            <GraduationCap
              className='~w-3.5/5 ~h-3.5/5 flex-shrink-0 text-primary-500 dark:text-primary-dark-500 ~mt-0.5/1'
              fill='currentColor'
              fillDarkMode='currentColor'
            />
            {t('tabs_revamp.advanced_tab.tutorial')}
          </h3>
          <p className='~text-xs/sm text-gray-600 dark:text-gray-400'>
            {t('tabs_revamp.advanced_tab.tutorial_description')}
          </p>
        </div>

        <Select
          options={tutorialOptions}
          value={selectedTutorial?.id}
          onChange={(value) =>
            dispatch(updateMoreOptionTutorial(value || undefined))
          }
          size='sm'
          className='w-full'
          isDisabled={isFetchingTutorials}
          placeholder={t('tabs_revamp.advanced_tab.select_tutorial')}
        />
      </Card>
    </div>
  );
};

export default Tutorial;
